<template>
  <g fill-rule="evenodd">
    <path
      d="M8.22 11.8a3.6 3.6 0 113.6-3.59 3.6 3.6 0 01-3.6 3.6zm4.8 0h-.64l-.23-.2a5.2 5.2 0 10-.55.55l.21.23V13l4 3.99L17 15.8l-3.98-4z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SearchIcon",
});
</script>
